import ApiMethods from '../ApiMethods';
import Endpoints from '../Endpoints';

/**
 * RUTEX FAQ & Help Center API Manager Service
 */
export const FaqApiManager = {
  /**
   * Get administrative list of FAQs with filters
   * @param {object} params (search, categoria, is_active)
   */
  getFaqs: async (params = {}) => {
    return await ApiMethods.get(Endpoints.FAQS, { params });
  },

  /**
   * Create a new FAQ record
   * @param {object} faqData 
   */
  createFaq: async (faqData) => {
    return await ApiMethods.post(Endpoints.FAQS, faqData);
  },

  /**
   * Update an existing FAQ record
   * @param {string} id 
   * @param {object} faqData 
   */
  updateFaq: async (id, faqData) => {
    return await ApiMethods.put(Endpoints.FAQ_BY_ID(id), faqData);
  },

  /**
   * Toggle is_active status of an FAQ
   * @param {string} id 
   */
  toggleFaqStatus: async (id) => {
    return await ApiMethods.patch(Endpoints.TOGGLE_FAQ_STATUS(id));
  },

  /**
   * Permanently delete an FAQ record
   * @param {string} id 
   */
  deleteFaq: async (id) => {
    return await ApiMethods.delete(Endpoints.FAQ_BY_ID(id));
  },

  /**
   * Get mobile/public active FAQs
   * @param {object} params (search, categoria)
   */
  getMobileFaqs: async (params = {}) => {
    return await ApiMethods.get(Endpoints.MOBILE_FAQS, { params });
  },

  /**
   * Get administrative list of support tickets submitted from mobile app
   * @param {object} params (search, estatus)
   */
  getSupportTickets: async (params = {}) => {
    return await ApiMethods.get(Endpoints.SUPPORT_TICKETS, { params });
  },

  /**
   * Update status or admin notes of a support ticket
   * @param {string} id
   * @param {object} data (estatus, notas_admin)
   */
  updateSupportTicket: async (id, data) => {
    return await ApiMethods.patch(Endpoints.SUPPORT_TICKET_BY_ID(id), data);
  },

  /**
   * Delete a support ticket record
   * @param {string} id
   */
  deleteSupportTicket: async (id) => {
    return await ApiMethods.delete(Endpoints.SUPPORT_TICKET_BY_ID(id));
  },

  /**
   * Get global core settings (including support_phone)
   */
  getCoreSettings: async () => {
    return await ApiMethods.get(Endpoints.CORE_SETTINGS);
  },

  /**
   * Update support phone in global core settings
   * @param {string} support_phone
   */
  updateSupportPhone: async (support_phone) => {
    return await ApiMethods.put(Endpoints.CORE_SETTINGS, { support_phone });
  },
};

export default FaqApiManager;
